module.exports = __webpack_public_path__ + "static/frame-latitude-pay-8e3470dbb9d2863c086477a872dea509.jpg";